import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, Link } from "react-router-dom";
import { getOneRosterUserOrgs, UserOrgRequestState } from "../../../store/OneRoster/OneRosterUserAction";
import StatusCode from "../../../util/StatusCode";
import ActiveToggle from "../../misc/ActiveToggle";
import TableHorizontalPagedToggle from "../../misc/TableHorizontalPagedToggle";
import * as Helper from '../../../util/Helper';
import { useTranslation } from "react-i18next";
import { RootState } from "../../../store/store";


const OneRosterUserSchoolUnits = () => {
    const { t } = useTranslation(['common', 'oneRoster']);

    const { userId } = useParams();
    const dispatch = useDispatch();
    const userSchools = useSelector<RootState, UserOrgRequestState>(state => state.onerosterUser.userSchool);
    const [show, setShow] = useState(true);

    useEffect(() => {
        if (userId) {
            getOneRosterUserOrgs(userId, {})(dispatch);
        }
    }, [dispatch, userId]);


    const updateFilter = (value: number | boolean, name: string) => {
        const filter = { ...userSchools.filter };
        if (name === "onlyActive") {
            filter["page"] = 1;
        }
        if (userId) {
            getOneRosterUserOrgs(userId, { ...filter, [name]: value })(dispatch);
        }
    }

    const mapUserSchoolInfo = () => {
        if (userSchools.code !== StatusCode.COMPLETE) {
            return [];
        }

        return userSchools.data?.values.map(us => ({
            id: us.id,
            data: [
                { value: <Link to={`/oneroster/schoolunit/${us.id}/information`}>{us.name}</Link> },
                { value: Helper.active(us.active) },
                { value: Helper.formatDate(us.created), classname: 'nowrap' },
                { value: Helper.formatDate(us.modified), classname: 'nowrap' },
            ]
        }));
    }

    const renderUserSchoolInfo = () => {
        return (
            <TableHorizontalPagedToggle
                header={[{ value: t('genericTableHeaders.name', { ns: 'common' }) }, { value: t('genericTableHeaders.active', { ns: 'common' }) }, { value: t('genericTableHeaders.created', { ns: 'common' }) }, { value: t('genericTableHeaders.modified', { ns: 'common' }) }]}
                info={mapUserSchoolInfo()}
                show={show}
                toggle={() => setShow(!show)}
                onChangePage={(p) => updateFilter(p, 'page')}
                noResultMsg="Den här användaren saknar skolkopplingar"
                requestState={userSchools}
            />
        )
    }

    const count = Helper.getTotalCountText(userSchools)
    return (<>
        <div className="header_member_table large"> {t('schoolConnections', { ns: 'oneRoster' })} {count}
            <span className="right">
                <ActiveToggle
                    onlyActive={userSchools.filter?.onlyActive ?? true}
                    update={(active) => updateFilter(active, 'onlyActive')}
                    disabled={userSchools.code === StatusCode.PENDING}
                />
            </span></div>
        {renderUserSchoolInfo()}
    </>);
}

export default OneRosterUserSchoolUnits;
